import { render, staticRenderFns } from "./feature-tr.vue?vue&type=template&id=105a77a8"
import script from "./feature-tr.vue?vue&type=script&lang=js"
export * from "./feature-tr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports